// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getImages as getImagesAPI
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { imagesApiResponseError, imagesApiResponseSuccess } from './actions';
import { ImagesActionTypes } from './constants';

// const api = new APICore();

/**
 * Get images
 * @param {*} payload - username and password
 */
function* getImages({ payload: { ownerId } }) {
    try {
        const response = yield call(getImagesAPI, ownerId);
        const images = response.data.data;
        yield put(imagesApiResponseSuccess(ImagesActionTypes.GET_IMAGES, images));
    } catch (error) {
        yield put(imagesApiResponseError(ImagesActionTypes.GET_IMAGES, error));
    }
}

export function* watchGetImages(): any {
    yield takeEvery(ImagesActionTypes.GET_IMAGES, getImages);
}

function* imagesSaga(): any {
    yield all([
        fork(watchGetImages)
    ]);
}

export default imagesSaga;
